import React, { ReactNode } from 'react';
import cn from 'classnames';
import { OrderStatus } from 'services/requests';

import styles from './TransactionCell.module.css';

type TransactionCellProps = {
  children: ReactNode | string;
  orderStatus: OrderStatus;
  isUserRelated: boolean;
};

const TransactionCell: React.FC<TransactionCellProps> = ({
  children,
  orderStatus,
  isUserRelated,
}) => {
  const isCanceled = orderStatus === OrderStatus.CANCELED;
  const isPending = orderStatus === OrderStatus.PENDING;

  return (
    <div
      className={cn({
        [styles.red]: isCanceled,
        [styles.gray]: isPending && isUserRelated,
      })}
    >
      {children}
    </div>
  );
};
export default TransactionCell;
